import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Custom hook for retrieving the search query from the URL.
 *
 * @returns {string} - The current search string (default is an empty string).
 */
function useSearch(): string {
	const [searchParams] = useSearchParams();
	return useMemo(() => searchParams.get('search') || '', [searchParams]);
}

export default useSearch;
